import React from 'react';
import { premiumTomos } from '../data/content';
export function PremiumUpsell() {
  return <section aria-labelledby="premium-title" className="bg-dusk" data-id="element-197" data-mp="yapp82ry1urr">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-198" data-mp="y9ek9zmrigz2">
        <div className="max-w-3xl" data-id="element-199" data-mp="tauufo51sl1f">
          <p className="font-display text-lg font-semibold text-pumpkin" data-id="element-200" data-mp="tdzabirvl57x">¿Qué agregan los 2 tomos premium?</p>
          <h2 id="premium-title" className="mt-3 font-display text-4xl font-bold leading-tight text-bone sm:text-5xl" data-id="element-201" data-mp="jdylxif5fywv">
            Para familias que quieren que su Halloween sea el evento del que todos hablan durante meses
          </h2>
          <p className="mt-5 text-lg text-mist" data-id="element-202" data-mp="ampw4w75tsa0">
            Sin los tomos premium la fiesta es divertida. <strong className="text-bone" data-id="element-203" data-mp="5nms9f2x1s3m">Con los tomos premium la fiesta se vuelve legendaria.</strong>
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-204" data-mp="mp9b0a30u12">
          <div className="rounded-3xl p-7 ring-1 ring-line" data-id="element-205" data-mp="3rtic28kix17p">
            <h3 className="font-display text-xl font-semibold text-mist" data-id="element-206" data-mp="3rw4j873i5epe">Sin Premium</h3>
            <p className="mt-3 leading-relaxed text-mist" data-id="element-207" data-mp="2lrpsma6h7i8f">
              Tenés decoración, juegos, disfraces y mesa dulce. La noche sale bien y todos se van contentos.
            </p>
          </div>
          <div className="rounded-3xl bg-plum p-7 ring-2 ring-pumpkin" data-id="element-208" data-mp="2btifk2fb5kbp">
            <h3 className="font-display text-xl font-semibold text-pumpkin" data-id="element-209" data-mp="2gv7ptfuphtyq">Con Premium</h3>
            <p className="mt-3 leading-relaxed text-bone" data-id="element-210" data-mp="34lljfasxw0vf">
              Agregás una experiencia cultural de terror argentino y una historia interactiva para leer a oscuras que convierte tu fiesta en un evento que nadie olvida jamás.
            </p>
          </div>
        </div>

        <h3 className="mt-16 font-display text-2xl font-semibold text-bone" data-id="element-211" data-mp="2zkeb9amvwzo8">Los 2 tomos premium incluyen:</h3>
        <ul className="mt-6 divide-y divide-line border-y border-line" data-id="element-212" data-mp="1j5w98mep41l5">
          {premiumTomos.map(t => <li key={t.code} className="grid gap-4 py-8 sm:grid-cols-[6rem_16rem_1fr] sm:gap-8" data-id="element-213" data-mp="1o6tu56r3b9qc">
              <span className="font-display text-4xl font-bold text-pumpkin" data-id="element-214" data-mp="3qreb41ri5xxh">{t.code}</span>
              <h4 className="font-display text-2xl font-semibold leading-tight text-bone" data-id="element-215" data-mp="3luxl120qt9hr">{t.title}</h4>
              <p className="leading-relaxed text-mist" data-id="element-216" data-mp="3h1l8hq9c8t5d">{t.text}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}